<template>
  <div class="wd">
    <el-row :gutter="20" class="wd-stat">
      <el-col :xs="24" :md="8">
        <div class="wd-stat__card wd-stat__card--primary">
          <div class="wd-stat__row">
            <img class="wd-stat__ico" :src="sliceW('balance.png')" alt="" />
            <div class="wd-stat__txt">
              <div class="wd-stat__lab">待审核金额 (USDT)</div>
              <div class="wd-stat__val">{{ formatDec(pendingUsdt) }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :md="8">
        <div class="wd-stat__card wd-stat__card--lite">
          <div class="wd-stat__row">
            <img class="wd-stat__ico" :src="sliceW('cumulative_count.png')" alt="" />
            <div class="wd-stat__txt">
              <div class="wd-stat__lab">累计提现笔数 (次)</div>
              <div class="wd-stat__val wd-stat__val--dark">{{ formatInt(totalCount) }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :md="8">
        <div class="wd-stat__card wd-stat__card--lite">
          <div class="wd-stat__row">
            <img class="wd-stat__ico" :src="sliceW('cumulative_amount.png')" alt="" />
            <div class="wd-stat__txt">
              <div class="wd-stat__lab">累计已提现 (USDT)</div>
              <div class="wd-stat__val wd-stat__val--dark">{{ formatDec(paidUsdt) }}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="wd-table-panel">
      <div class="wd-table-panel__h">
        <div class="wd-table-panel__title">
          <img :src="sliceW('records.png')" class="wd-table-panel__ico" alt="" />
          提现流水记录
        </div>
        <div class="wd-table-panel__bar">
          <div class="wd-sel-wrap wd-sel-wrap--sm">
            <el-select
              v-model="listFilter.status"
              class="wd-sel"
              size="small"
              popper-class="wd-select-popper"
              @change="loadWithdrawals(1)"
            >
              <el-option label="全部状态" value="" />
              <el-option label="待审核" value="0" />
              <el-option label="已入账" value="1" />
              <el-option label="已拒绝" value="2" />
            </el-select>
            <img :src="sliceW('select.png')" class="wd-sel-ico" alt="" role="presentation" />
          </div>
          <el-input
            v-model="listFilter.keyword"
            class="wd-search"
            size="small"
            clearable
            placeholder="搜索交易 Hash / 地址"
            @keyup.enter.native="loadWithdrawals(1)"
          >
            <span slot="prefix" class="wd-search-prefix">
              <img :src="sliceW('search.png')" class="wd-search-ico" alt="" role="presentation" />
            </span>
          </el-input>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="listRows" class="wd-table" size="small" style="width: 100%">
        <el-table-column label="商户" min-width="120">
          <template slot-scope="s">
            <span class="cell-muted">{{ s.row.merchantName || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="钱包地址" min-width="160">
          <template slot-scope="s">
            <div class="wd-cell-addr">
              <button type="button" class="wd-addr-tap" :title="s.row.address" @click="openAddrExplorer(s.row)">
                {{ shortAddr(s.row.address) }}
              </button>
              <button type="button" class="wd-copy" title="复制" @click="copyText(s.row.address)">
                <img :src="sliceW('copy.png')" alt="" />
              </button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提现金额" min-width="150">
          <template slot-scope="s">
            <div class="wd-amt-gross">{{ formatAmount(s.row.amount) }} {{ s.row.coin }}</div>
            <div class="wd-arrive">
              <img :src="sliceW('get.png')" class="wd-arrive-ico" alt="" role="presentation" />
              到账 {{ formatAmount(s.row.paid) }} {{ s.row.coin }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="币种" width="100">
          <template slot-scope="s">
            <span class="wd-coin" :class="'wd-coin--' + s.row.coin.toLowerCase()">{{ s.row.coin }}</span>
          </template>
        </el-table-column>
        <el-table-column label="链" width="100">
          <template slot-scope="s">
            <span class="wd-chain-pill">{{ displayTableChain(s.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易 HASH" min-width="130">
          <template slot-scope="s">
            <explorer-cell v-if="s.row.txHash" kind="tx" :chain="s.row.chain" :value="s.row.txHash" />
            <span v-else class="cell-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" min-width="160">
          <template slot-scope="s">
            <div class="wd-time-app">
              <img :src="sliceW('time.png')" class="wd-time-ico" alt="" role="presentation" />
              <span>{{ s.row.createdAt || '—' }}</span>
            </div>
            <div class="wd-time-upd">更新 {{ s.row.updatedAt || '—' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="s">
            <span :class="['wd-st', s.row.stClass]">{{ s.row.stLabel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="s">
            <el-button
              v-if="s.row.status === 0"
              type="text"
              size="small"
              @click="openAudit(s.row)"
            >审核</el-button>
            <el-button
              v-else-if="s.row.status === 2"
              type="text"
              size="small"
              @click="openDetail(s.row)"
            >查看</el-button>
            <span v-else class="cell-muted">—</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="wd-pager">
        <span class="wd-pager__sum">显示 {{ rangeFrom }} - {{ rangeTo }} / 共 {{ total | fmtNum }} 条</span>
        <el-pagination
          background
          class="wd-pager__el"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 15, 20, 50]"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @size-change="onSize"
          @current-change="onPage"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="auditVisible"
      width="600px"
      custom-class="wdl-dialog wdl--merchant-view"
      :show-close="false"
      :close-on-click-modal="false"
      @close="onAuditClose"
    >
      <div v-if="auditRow" class="wd-audit">
        <div class="wdl-hero wdl-hero--sm wdl-hero--mc" :style="modalBg">
          <div class="wdl-hero__stack">
            <div class="wdl-hero-txt">提现详情记录</div>
          </div>
          <button type="button" class="wdl-x wdl-x--round" @click="auditVisible = false">
            <img :src="sliceCloseModal()" alt="关闭" />
          </button>
        </div>
        <div class="wd-audit-body">
          <div class="wd-audit-sum">
            <div class="wd-audit-sum__lab">提现到账金额 ({{ auditRow.coin }})</div>
            <div class="wd-audit-sum__val">{{ formatAmount(auditRow.paid) }} <span class="wd-audit-sum__coin">{{ auditRow.coin }}</span></div>
            <div class="wd-audit-sum__tag">{{ displayTableChain(auditRow) }}</div>
          </div>
          <div class="wd-audit-card">
            <div class="wd-audit-line">
              <span class="wd-audit-k">商户</span>
              <span class="wd-audit-v">{{ auditRow.merchantName || '—' }}</span>
            </div>
            <div class="wd-audit-line">
              <span class="wd-audit-k">提现金额</span>
              <span class="wd-audit-v">{{ formatAmount(auditRow.amount) }} {{ auditRow.coin }}</span>
            </div>
            <div class="wd-audit-line wd-audit-line--addr">
              <span class="wd-audit-k">提现地址</span>
              <div class="wd-audit-addr">
                <span class="wd-audit-addr__txt" :title="auditRow.address">{{ shortAddr(auditRow.address) }}</span>
                <button type="button" class="wd-audit-addr__copy" @click="copyText(auditRow.address)">
                  <img :src="sliceW('copy.png')" alt="复制" />
                </button>
              </div>
            </div>
            <div class="wd-audit-line">
              <span class="wd-audit-k">审核结果</span>
              <span :class="['wd-st', auditRow.stClass]">{{ auditRow.stLabel }}</span>
            </div>
          </div>
          <div class="wd-audit-sec">审核意见</div>
          <div class="wd-audit-choices" role="group" aria-label="审核意见">
            <button
              type="button"
              :class="['wd-audit-ch', { 'is-sel': auditForm.decision === 'approve' }]"
              @click="auditForm.decision = 'approve'"
            >
              <img
                :src="sliceW(auditForm.decision === 'approve' ? 'agree_choose.png' : 'agree.png')"
                alt=""
                role="presentation"
              />
              <span>同意申请</span>
            </button>
            <button
              type="button"
              :class="['wd-audit-ch', { 'is-sel': auditForm.decision === 'reject' }]"
              @click="auditForm.decision = 'reject'"
            >
              <img
                :src="sliceW(auditForm.decision === 'reject' ? 'reject_choose.png' : 'reject.png')"
                alt=""
                role="presentation"
              />
              <span>拒绝申请</span>
            </button>
          </div>
          <el-form v-if="auditForm.decision === 'approve'" label-position="top" size="small" class="wd-audit-form">
            <el-form-item label="实际打款金额 (与币种一致)">
              <el-input v-model="auditForm.paid_amount" clearable class="wd-audit-inp" />
            </el-form-item>
            <el-form-item label="交易 Hash">
              <el-input v-model="auditForm.tx_hash" type="textarea" :rows="2" clearable class="wd-audit-txa" />
            </el-form-item>
          </el-form>
          <div v-else class="wd-audit-rej">
            <div class="wd-audit-sec">拒绝理由</div>
            <el-input
              v-model="auditForm.reject_reason"
              type="textarea"
              :rows="4"
              class="wd-audit-txa"
              placeholder="请输入拒绝提现的具体原因，商户将可见此内容…"
            />
          </div>
          <div class="wd-audit-foot">
            <el-button class="wd-audit-foot__back" @click="auditVisible = false">取消返回</el-button>
            <el-button type="primary" class="wd-audit-foot__ok" :loading="auditLoading" @click="submitAudit">立即确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dlgDetail"
      width="500px"
      custom-class="wd-detail-dlg"
    >
      <div class="wdl-dh">
        提现详情记录
        <button type="button" class="wdl-x" @click="dlgDetail = false"><img :src="sliceAddr('close.png')" alt="关闭" /></button>
      </div>
      <div v-if="detailRow" class="wdl-dbody">
        <div class="wdl-damt">
          <div class="wdl-damt-lab">提现到账 ({{ detailRow.coin }})</div>
          <div class="wdl-damt-val">{{ formatAmount(detailRow.paid) }} <small class="wdl-damt-coin">{{ detailRow.coin }}</small></div>
          <div class="wdl-dtag">{{ displayTableChain(detailRow) }}</div>
        </div>
        <div class="wdl-drow"><span>商户</span><span>{{ detailRow.merchantName || '—' }}</span></div>
        <div class="wdl-drow"><span>提现金额</span><span>{{ formatAmount(detailRow.amount) }} {{ detailRow.coin }}</span></div>
        <div class="wdl-drow"><span>提现地址</span>
          <div class="wdl-daddr">
            <explorer-cell kind="address" :chain="detailRow.chain" :value="detailRow.address" />
            <button type="button" class="wd-copy" @click="copyText(detailRow.address)">
              <img :src="sliceW('copy.png')" alt="" />
            </button>
          </div>
        </div>
        <div class="wdl-drow"><span>审核结果</span>
          <span :class="['wd-st', detailRow.stClass]">{{ detailRow.stLabel }}</span>
        </div>
        <div v-if="detailRow.status === 2 && detailRow.reject" class="wdl-rr">
          <div class="wdl-rr-t">拒绝理由</div>
          <p>{{ detailRow.reject }}</p>
        </div>
        <el-button class="wdl-dok" @click="dlgDetail = false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminApi } from '@/api/admin'
import ExplorerCell from '@/components/ExplorerCell.vue'
import { addressExplorerUrl } from '@/utils/explorers'

export default {
  name: 'AdminWithdrawView',
  components: { ExplorerCell },
  filters: {
    fmtNum(n) {
      return Number(n || 0).toLocaleString('en-US')
    }
  },
  data() {
    return {
      pendingUsdt: '0',
      totalCount: 0,
      paidUsdt: '0',
      listRows: [],
      listLoading: false,
      listFilter: { status: '', keyword: '' },
      page: 1,
      pageSize: 15,
      total: 0,
      auditVisible: false,
      auditRow: null,
      auditForm: { decision: 'approve', paid_amount: '', tx_hash: '', reject_reason: '' },
      auditLoading: false,
      dlgDetail: false,
      detailRow: null
    }
  },
  computed: {
    rangeFrom() {
      if (!this.total) return 0
      return (this.page - 1) * this.pageSize + 1
    },
    rangeTo() {
      if (!this.total) return 0
      return Math.min(this.page * this.pageSize, this.total)
    },
    /** 与商户管理弹窗一致：提现地址目录 modal_bg */
    modalBg() {
      return {
        backgroundImage: `url('${this.sliceAddr('modal_bg.png')}')`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top'
      }
    }
  },
  created() {
    document.documentElement.style.setProperty(
      '--ord-choose-wd',
      `url('${this.sliceO('choose.png')}')`
    )
  },
  beforeDestroy() {
    document.documentElement.style.removeProperty('--ord-choose-wd')
  },
  mounted() {
    this.loadSummary()
    this.loadWithdrawals(1)
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    },
    sliceW(n) {
      return this.base() + 'slices/withdraw/' + encodeURIComponent(n)
    },
    sliceO(n) {
      return this.base() + 'slices/order/' + encodeURIComponent(n)
    },
    sliceAddr(n) {
      return this.base() + 'slices/withdraw/address/' + encodeURIComponent(n)
    },
    sliceCloseModal() {
      return this.base() + 'slices/' + encodeURIComponent('close_modal.png')
    },
    displayTableChain(row) {
      const c = (row.coin || '').toUpperCase()
      if (c === 'BTC' || c === 'ETH') return 'Native'
      return row.chain || '—'
    },
    mapWithdrawRow(r) {
      const status = r.status
      const stMap = { 0: { label: '待审核', cls: 'is-pend' }, 1: { label: '已入账', cls: 'is-ok' }, 2: { label: '已拒绝', cls: 'is-deny' } }
      const s = stMap[status] || { label: '—', cls: '' }
      const amount = r.amount
      const fee = parseFloat(r.fee) || 0
      const paid = r.paid_amount != null && r.paid_amount !== '' ? parseFloat(r.paid_amount) : Math.max(0, (parseFloat(amount) || 0) - fee)
      return {
        id: r.id,
        raw: r,
        merchantName: (r.merchant && r.merchant.name) || '',
        coin: (r.coin || '').toUpperCase(),
        chain: r.chain,
        amount,
        fee,
        paid,
        address: r.address,
        txHash: (r.tx_hash || '').trim(),
        createdAt: this.shortTime(r.created_at),
        updatedAt: this.shortTime(r.updated_at),
        status,
        stLabel: s.label,
        stClass: s.cls,
        reject: r.reject_reason || ''
      }
    },
    shortTime(t) {
      if (!t) return '—'
      const s = String(t)
      if (s.length > 19) return s.slice(0, 16)
      return s.replace('T', ' ')
    },
    formatDec(n) {
      const x = parseFloat(n) || 0
      return x.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatInt(n) {
      return Number(n || 0).toLocaleString('en-US')
    },
    formatAmount(n) {
      const x = parseFloat(n) || 0
      if (x >= 1e6) return x.toLocaleString('en-US', { maximumFractionDigits: 2 })
      return x.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })
    },
    async loadSummary() {
      try {
        const r = await adminApi.withdrawalsSummary()
        const d = r.data || {}
        this.pendingUsdt = d.pending_amount_usdt != null ? String(d.pending_amount_usdt) : '0'
        this.totalCount = d.total_count != null ? d.total_count : 0
        this.paidUsdt = d.total_paid_usdt != null ? String(d.total_paid_usdt) : '0'
      } catch (e) {
        /* 静默 */
      }
    },
    async loadWithdrawals(p) {
      if (p) this.page = p
      this.listLoading = true
      try {
        const r = await adminApi.withdrawals({
          page: this.page,
          page_size: this.pageSize,
          status: this.listFilter.status,
          keyword: (this.listFilter.keyword || '').trim()
        })
        const d = r.data || {}
        this.total = d.total != null ? d.total : 0
        this.listRows = (d.list || []).map((x) => this.mapWithdrawRow(x))
      } catch (e) {
        this.listRows = []
        this.total = 0
      } finally {
        this.listLoading = false
      }
    },
    onPage(p) {
      this.page = p
      this.loadWithdrawals()
    },
    onSize(n) {
      this.pageSize = n
      this.loadWithdrawals(1)
    },
    openDetail(row) {
      this.detailRow = row
      this.dlgDetail = true
    },
    openAudit(row) {
      this.auditRow = row
      this.auditForm = {
        decision: 'approve',
        paid_amount: String(row.amount),
        tx_hash: '',
        reject_reason: ''
      }
      this.auditVisible = true
    },
    onAuditClose() {
      this.auditRow = null
    },
    async submitAudit() {
      if (!this.auditRow) return
      if (this.auditForm.decision === 'approve') {
        const a = (this.auditForm.paid_amount || '').trim()
        const h = (this.auditForm.tx_hash || '').trim()
        if (!a || !h) {
          this.$message.warning('通过审核需填写打款金额与交易 Hash')
          return
        }
      } else {
        const r = (this.auditForm.reject_reason || '').trim()
        if (!r) {
          this.$message.warning('请填写拒绝理由')
          return
        }
      }
      this.auditLoading = true
      try {
        const id = this.auditRow.id
        const body =
          this.auditForm.decision === 'approve'
            ? { decision: 'approve', paid_amount: this.auditForm.paid_amount.trim(), tx_hash: this.auditForm.tx_hash.trim() }
            : { decision: 'reject', reject_reason: (this.auditForm.reject_reason || '').trim() }
        await adminApi.withdrawalAudit(id, body)
        this.$message.success('操作成功')
        this.auditVisible = false
        this.auditRow = null
        this.loadSummary()
        this.loadWithdrawals(this.page)
      } catch (e) {
        /* 拦截器已提示 */
      } finally {
        this.auditLoading = false
      }
    },
    shortAddr(v, pre = 6, end = 4) {
      if (!v) return '—'
      const t = String(v).trim()
      if (t.length <= pre + end + 3) return t
      return t.slice(0, pre) + '...' + t.slice(-end)
    },
    openAddrExplorer(row) {
      const u = addressExplorerUrl(row.chain, row.address)
      if (u) {
        const w = window.open(u, '_blank', 'noopener,noreferrer')
        if (w) w.opener = null
      } else {
        this.$message.info('该链暂无可用的浏览器链接')
      }
    },
    copyText(t) {
      if (!t) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t).then(() => this.$message.success('已复制'))
      } else {
        this.$message.warning('无法复制')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 商户页同款：顶卡 + 流水表 */
.wd {
  max-width: 100%;
  padding: 0;
}

.wd-stat {
  margin-bottom: 20px;
}
.wd-stat__card {
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 18px;
  min-height: 123px;
  box-sizing: border-box;
  &--primary {
    background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%);
    box-shadow: 0px 12px 40px -12px rgba(37, 99, 235, 0.3);
    border-radius: 24px;
    color: #fff;
    border: none;
    .wd-stat__lab {
      color: rgba(255, 255, 255, 0.9);
    }
  }
  &--lite {
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.02);
    border-radius: 24px;
    border: 1px solid rgba(243, 244, 246, 0.9);
  }
}
.wd-stat__row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 14px;
}
.wd-stat__ico {
  width: 50px;
  height: 50px;
  object-fit: contain;
  flex-shrink: 0;
}
.wd-stat__txt {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.wd-stat__lab {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  line-height: 1.3;
}
.wd-stat__val {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.2;
  &--dark {
    color: #0f172a;
  }
}
.wd-stat__card--primary .wd-stat__val {
  color: #fff;
}

.wd-sel-wrap {
  position: relative;
  &--sm {
    width: 120px;
  }
}
.wd-sel-ico {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
  z-index: 1;
}

.wd-table-panel {
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 24px;
  padding: 16px 18px 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}
.wd-table-panel__h {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.wd-table-panel__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}
.wd-table-panel__ico {
  width: 16px;
  height: 16px;
  object-fit: contain;
}
.wd-table-panel__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.wd-search {
  width: 240px;
  min-width: 0;
  ::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-radius: 10px;
    font-size: 13px;
    border: 1px solid #e2e8f0;
  }
  ::v-deep .el-input__prefix {
    left: 10px;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 30px;
  }
}
.wd-search-prefix {
  display: inline-flex;
  align-items: center;
  height: 100%;
}
.wd-search-ico {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

::v-deep .wd-table th {
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}
.wd-amt-gross {
  font-weight: 600;
  color: #0f172a;
  font-size: 13px;
}
.wd-arrive {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #2563eb;
  font-weight: 500;
  margin-top: 2px;
}
.wd-arrive-ico {
  width: 10px;
  height: 10px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}
.wd-coin {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  &--usdt {
    background: rgba(244, 114, 182, 0.2);
    color: #9d174d;
  }
  &--btc {
    background: rgba(255, 152, 0, 0.2);
    color: #b45309;
  }
  &--eth {
    background: rgba(129, 140, 248, 0.25);
    color: #4f46e5;
  }
}
.wd-chain-pill {
  display: inline-block;
  background: #f1f5f9;
  font-size: 12px;
  color: #475569;
  padding: 2px 8px;
  border-radius: 6px;
}
.wd-time-app {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #333333;
  line-height: 1.35;
}
.wd-time-ico {
  width: 10px;
  height: 10px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
  position: relative;
  top: 1px;
}
.wd-time-upd {
  font-size: 10px;
  font-weight: 500;
  color: #6a7282;
  line-height: 1.4;
  margin-top: 2px;
}
.wd-st {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  &.is-ok {
    color: #059669;
    background: rgba(16, 185, 129, 0.12);
  }
  &.is-pend {
    color: #d97706;
    background: rgba(245, 158, 11, 0.15);
  }
  &.is-deny {
    color: #dc2626;
    background: rgba(248, 113, 113, 0.12);
  }
}
.wd-cell-addr {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.wd-addr-tap {
  min-width: 0;
  padding: 0;
  margin: 0;
  text-align: left;
  background: none;
  border: none;
  color: #2563eb;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  cursor: pointer;
  line-height: 1.35;
  word-break: break-all;
  &:hover {
    text-decoration: underline;
  }
}
.wd-copy {
  flex-shrink: 0;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 12px;
    height: 12px;
    object-fit: contain;
  }
}
.cell-muted {
  color: #94a3b8;
}

.wd-pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 4px;
  gap: 8px;
}
.wd-pager__sum {
  font-size: 12px;
  color: #64748b;
}
.wd-pager__el {
  ::v-deep .el-pager li.active {
    background: #3b82f6 !important;
  }
}

.wd-audit-body {
  padding: 24px 32px 28px;
  background: #fff;
  box-sizing: border-box;
}
.wd-audit-sum {
  text-align: center;
  margin-bottom: 20px;
}
.wd-audit-sum__lab {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  margin-bottom: 8px;
}
.wd-audit-sum__val {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
  margin-bottom: 8px;
}
.wd-audit-sum__coin {
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
}
.wd-audit-sum__tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
}
.wd-audit-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 20px;
  background: #fafbfc;
}
.wd-audit-line {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
  &--addr {
    align-items: center;
  }
}
.wd-audit-k {
  color: #94a3b8;
  font-weight: 500;
  flex-shrink: 0;
}
.wd-audit-v {
  color: #0f172a;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}
.wd-audit-addr {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  justify-content: flex-end;
}
.wd-audit-addr__txt {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  color: #0f172a;
  font-weight: 600;
}
.wd-audit-addr__copy {
  flex-shrink: 0;
  padding: 4px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
  border-radius: 8px;
  &:hover {
    background: #e2e8f0;
  }
  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
    display: block;
  }
}
.wd-audit-sec {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 10px;
}
.wd-audit-choices {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 12px;
  margin-bottom: 16px;
}
.wd-audit-ch {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 12px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  box-sizing: border-box;
  transition: background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
  &:hover {
    border-color: #cbd5e1;
  }
  &.is-sel {
    border: none;
    color: #fff;
    background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%);
    box-shadow: 0 2px 4px -2px rgba(43, 127, 255, 0.2), 0 4px 6px -1px rgba(43, 127, 255, 0.2);
  }
}
.wd-audit-rej {
  margin-bottom: 8px;
}
::v-deep .wd-audit-txa .el-textarea__inner {
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  border-color: #fecdd3;
  &:focus {
    border-color: #f87171;
  }
}
::v-deep .wd-audit-inp .el-input__inner {
  height: 44px;
  line-height: 44px;
  border-radius: 12px;
  border-color: #e2e8f0;
}
.wd-audit-foot {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  gap: 12px;
  margin-top: 20px;
  padding-top: 4px;
}
.wd-audit-foot__back {
  flex: 1 1 0;
  min-width: 0;
  margin: 0 !important;
  height: 44px !important;
  padding: 0 20px !important;
  line-height: 44px !important;
  font-size: 15px;
  font-weight: 500;
  color: #64748b !important;
  background: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  &:hover {
    background: #e8eef5 !important;
  }
}
.wd-audit-foot__ok {
  flex: 1 1 0;
  min-width: 0;
  margin: 0 !important;
  height: 44px !important;
  padding: 0 24px !important;
  line-height: 44px !important;
  font-size: 15px;
  font-weight: 600;
  border: none !important;
  border-radius: 14px !important;
  color: #fff !important;
  background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%) !important;
  box-shadow: 0 2px 4px -2px rgba(43, 127, 255, 0.2), 0 4px 6px -1px rgba(43, 127, 255, 0.2);
  &:hover,
  &:focus {
    background: linear-gradient(221deg, #0646d4 0%, #0e4bdc 7.39%, #00a3e0 100%) !important;
  }
}

/* 详情弹窗（从商户页摘必要块） */
.wd-detail-dlg {
  border-radius: 20px;
  overflow: hidden;
}
::v-deep .wd-detail-dlg .el-dialog__header {
  display: none;
}
::v-deep .wd-detail-dlg .el-dialog__body {
  padding: 0;
}
.wdl-dh {
  position: relative;
  padding: 20px 48px 16px 20px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  border-bottom: 1px solid #eef2f7;
}
.wdl-x {
  position: absolute;
  right: 12px;
  top: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  line-height: 0;
  img {
    width: 18px;
    height: 18px;
    opacity: 0.5;
  }
}
.wdl-dbody {
  padding: 20px 20px 24px;
}
.wdl-damt {
  text-align: center;
  margin-bottom: 20px;
}
.wdl-damt-lab {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 6px;
}
.wdl-damt-val {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 6px;
}
.wdl-damt-coin {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}
.wdl-dtag {
  display: inline-block;
  background: #f1f5f9;
  font-size: 12px;
  color: #475569;
  padding: 2px 10px;
  border-radius: 6px;
}
.wdl-drow {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  font-size: 13px;
  margin-bottom: 12px;
  & > span:first-child {
    color: #94a3b8;
    flex-shrink: 0;
  }
}
.wdl-daddr {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  justify-content: flex-end;
}
.wdl-rr {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 8px;
}
.wdl-rr-t {
  font-size: 12px;
  font-weight: 600;
  color: #b91c1c;
  margin-bottom: 4px;
}
.wdl-rr p {
  margin: 0;
  font-size: 13px;
  color: #7f1d1d;
  line-height: 1.5;
  word-break: break-word;
}
.wdl-dok {
  width: 100%;
  margin-top: 16px;
  border-radius: 10px;
}
</style>

<style lang="scss">
.wd-select-popper.el-select-dropdown {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}
.wd-select-popper .el-select-dropdown__item.selected {
  color: #2563eb;
  font-weight: 600;
  position: relative;
  padding-right: 32px;
  &::after {
    content: '';
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    background: var(--ord-choose-wd) center / contain no-repeat;
  }
}

/* 与 AdminMerchantsView：商户/审核弹窗标头、关闭 */
.wdl-dialog.wdl--merchant-view {
  border-radius: 28px;
  overflow: hidden;
  margin-top: 5vh !important;
}
.wdl-dialog.wdl--merchant-view .el-dialog__header,
.wdl-dialog.wdl--merchant-view .el-dialog__body {
  padding: 0;
}
.wdl-dialog.wdl--merchant-view .el-dialog__headerbtn {
  display: none;
}
.wdl-hero--mc {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 72px;
  box-sizing: border-box;
  padding: 18px 68px 18px 24px;
  border-radius: 0;
}
.wdl-hero__stack {
  flex: 1;
  min-width: 0;
  text-align: left;
}
.wdl-hero--mc .wdl-hero__stack .wdl-hero-txt {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wdl-hero--mc .wdl-x {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  box-shadow: 0 1px 2px -1px rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  box-sizing: border-box;
  cursor: pointer;
  line-height: 0;
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  &.wdl-x--round {
    border-radius: 50%;
    background: #fff;
    border: none;
    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
  }
}
</style>
